import React, {useEffect, useState} from "react";
import { Image } from "@arctheme-components/elements/Image/Image";
import useVideoSource from "@arctheme-hooks/useVideoSourceQuality";

const MediaArea = ({ globals, settings, isMobile }) => {
    const layout = isMobile ? settings.layout_type : settings.layout_type_mobile;
    const image = isMobile ? settings.image_mobile : settings.image;
    const [videoSources, setVideoSources]: any = useState([]);
    
    // Check if this is a badge-style display (like the Shopify Integration Specialists image)
    const isBadgeStyle = settings?.badge_style === true;

    // Pre-process the video sources using the hook
    const videoSettings = isMobile
        ? settings?.video_mobile
        : settings?.video;

    const videoSourcesToCheck = videoSettings?.sources;

    // Call the hook to get video URL and poster for each video block
    let processedVideos: any = null;
    let videoUrl: any = null;
    let videoPoster: any = null;
    if (videoSourcesToCheck) {
        const {videoUrl, videoPoster} = useVideoSource(
            videoSourcesToCheck,
            videoSettings?.preview_image,
            isMobile,
            globals.video_quality
        );

        processedVideos = {videoUrl, videoPoster};
    }

    useEffect(() => {
        if (processedVideos) {
            setVideoSources(processedVideos);
        }
    }, []); // useEffect will trigger when processedVideos changes

    if (isBadgeStyle) {
        return (
            <div className={`twi-${layout}__media flex items-center justify-center`}>
                <div className="flex flex-col items-center space-y-6">
                    {image && (
                        <img 
                            src={image} 
                            alt={settings.image_alt || "Shopify Partner Badge"} 
                            className="max-w-[80%] h-auto"
                        />
                    )}
                    {settings.badge_text && (
                        <div className="text-center font-semibold">
                            {settings.badge_text}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className={`twi-${layout}__media`}>
            {image ? (
                <Image imageUrl={image} classes={"object-cover h-full w-full"} />
            ) : videoSources.videoUrl ? (
                <video
                    className={"object-cover h-full w-full"}
                    autoPlay
                    loop
                    muted
                    poster={videoSources.videoPoster}
                    preload="metadata"
                    playsInline
                >
                    <source src={videoSources.videoUrl} type="video/mp4"></source>
                </video>
            ) : null}
        </div>
    );
};

export default MediaArea;
